import { Trans } from '@lingui/react/macro';

import { ActivityOfType } from '@/components/activities/Activity';
import { BaseActivity, BaseActivityText } from '@/components/activities/BaseActivity/BaseActivity';
import IconExchange from '@/icons/Exchange.svg';

export const ArticleExchangeProposedActivity = ({
  activity,
}: {
  activity: ActivityOfType<'article_exchange_proposed'>;
}) => {
  const creatorName = activity.creator.name;
  const productName = activity.data.replacementProduct.name;
  const stockLocationName = activity.entity.name;

  return (
    <BaseActivity
      createdAt={activity.createdAt}
      type="neutral"
      icon={<IconExchange />}
      message={
        <BaseActivityText>
          <Trans id="activities.article_exchange_proposed.message">
            <strong>{creatorName}</strong> proposed an exchange with product {productName} (stock
            location: {stockLocationName}).
          </Trans>
        </BaseActivityText>
      }
    />
  );
};
